<template>
  <div>
    <v-app v-if="!user.loggedInStatus">
      <login-page></login-page>
      <v-snackbar
        :timeout="snackbar.timeout"
        top
        right
        v-model="snackbar.show"
        :color="snackbar.type"
      >
        {{ snackbar.text }}
        <v-btn flat color="white" @click.native="snackbar.show = false">Закрыть</v-btn>
      </v-snackbar>
    </v-app>
    <v-app v-if="user.loggedInStatus" light>
      <v-navigation-drawer
        class="elevation-2 navigation"
        fixed
        v-model="miniVariant"
        mobile-break-point="4000"
        mini-variant-width="0"
      >
        <v-list>
          <v-list-tile @click.stop="miniVariant = false" class="no-hover">
            <v-icon light class="ml-auto">close</v-icon>
          </v-list-tile>
          <RouterLink to="/" class="navbar-link" @click.stop>
            <v-list-tile value="true" @click.stop="miniVariant = false">
              <v-icon light class="mr-2">dashboard</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Главная</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </RouterLink>

          <RouterLink
            class="navbar-link "
            :to="item.link"
            v-for="(item, i) in availableModules"
            :key="i"
          >
            <v-list-tile
              value="true"
              @click.stop="miniVariant = false"
            >
              <v-icon light v-html="item.icon" class="mr-2"></v-icon>
              <v-list-tile-content>
                <v-list-tile-title v-text="item.title"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </RouterLink>

          <v-list-tile class="navbar-link" value="true" @click="logout" exact>
            <v-icon class="mr-2" light>exit_to_app</v-icon>
            <v-list-tile-content>
              <v-list-tile-title>Выход</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <p class="version-text text-center " :class="[{'ml-3': !miniVariant}, {'version-text_center' :miniVariant}]">Версия продукта 2.6.3</p>
      </v-navigation-drawer>

      <v-toolbar
        dark
        fixed
        app
        elevation-1
        color="blue"
        class=" elevation-0 width-100 p-0"
        height="48"
      >

        <v-list-tile @click.stop="miniVariant = true" >
          <v-icon dark>menu</v-icon>
        </v-list-tile>

        <div style="width: 100%; display: flex; align-items: center;">
          <img src="../static/img/rivc_logo.png" class="rivc-logo" height="20px" />
        </div>

        <v-btn icon @click="refresh()">
          <v-icon>cached</v-icon>
        </v-btn>
        <v-btn icon @click="$router.push('/')" v-if="$route.path !== '/'">
          <v-icon>dashboard</v-icon>
        </v-btn>

        <v-btn icon @click="turnBlockSort" v-if="$route.path == '/'">
          <v-icon>{{ dragOptions.disabled ? 'flip_to_front' : 'done_all' }}</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        <div class="mr-1"></div>
      </v-toolbar>
      <v-content>
        <router-view></router-view>
      </v-content>
      <v-snackbar
        :timeout="snackbar.timeout"
        bottom
        right
        v-model="snackbar.show"
        :color="snackbar.type"
      >
        {{ snackbar.text }}
        <v-btn flat color="white" @click.native="snackbar.show = false">Закрыть</v-btn>
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import loginPage from '@/components/pages/login'
import { eventBus } from './eventBus'
export default {
  data() {
    return {
      user: store.getters.getUser,
      cordova: Vue.cordova,
      drawer: false,
      dragOptions: store.getters.getDragOptions,
      snackbar: store.getters.getSnackbar,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'BossDashboard',
      version: '[dev]',
    }
  },
  computed: {
    availableModules: {
      get() {
        return store.getters.getAvailableModules
      },
    },
  },
  components: {
    'login-page': loginPage,
  },
  created() {
    var self = this
    this.cordova.on('deviceready', () => {
      self.onDeviceReady()
    })
  },
  methods: {
    onDeviceReady: function() {
      // Handle the device ready event.
      this.cordova.on('pause', this.onPause, false)
      this.cordova.on('resume', this.onResume, false)
      if (this.cordova.device.platform === 'Android') {
        document.addEventListener('backbutton', this.onBackKeyDown, false)
      }
    },
    onPause() {
      // Handle the pause lifecycle event.
      console.log('pause')
    },
    onResume() {
      // Handle the resume lifecycle event.
      // SetTimeout required for iOS.
      setTimeout(function() {
        console.log('resume')
      }, 0)
    },
    onBackKeyDown() {
      // Handle the back-button event on Android. By default it will exit the app.
      navigator.app.exitApp()
    },
    routerPush(link) {
      this.$router.push(link)
    },
    logout() {
      store.dispatch('logout')
    },
    showMsg: function(text, type, timeout) {
      store.dispatch('showMsg', { text: text, type: type, timeout: timeout })
    },
    changeDragOptions: function(dragOptions) {
      store.commit('setDragOptions', dragOptions)
    },
    turnBlockSort: function() {
      let opt = this.dragOptions
      let text = opt.disabled ? 'ВКЛЮЧЕН' : 'ОТКЛЮЧЕН'
      opt.disabled = !opt.disabled
      this.changeDragOptions(opt)
      this.showMsg('Режим настройки интерфейса - ' + text, 'primary')
    },
    refresh: async function() {
      let updated = await store.dispatch('globalDataUpdate')
      if (updated) {
        eventBus.$emit('refresh')
      }
    },
  },
}
</script>

<style>
body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}
.footer {
  /* Apply this to v-bottom-nav if necessary. */
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}
.navbar-link, .navbar-link .v-list__tile__title {
  color: #8AA1AC !important;
  fill: #8AA1AC;
  text-decoration: none;
  font-weight: 600;
}
.router-link-exact-active, .router-link-exact-active .v-list__tile__title, .router-link-exact-active i {
  color: #1976d2 !important;
}
.version-text {
  font-size: 10px;
  color: #8AA1AC;
}
.version-text_center {
  text-align: center;
}
.content-left-gap {
  padding-left: 60px !important;
}
.navigation, .elevation-0 {
  z-index: 100;
}
.no-hover .v-list__tile--link:hover {
  &:hover {
    background: transparent;
  }
}
</style>
